import { createSegmentActionsPlugin } from '@amplitude/segment-session-replay-plugin';
import { AnalyticsBrowser, type EventProperties } from '@segment/analytics-next';
import { UAParser } from 'ua-parser-js';
import { isDevelopment } from '../utils/common/checkEnv';
import { getEnv } from '../utils/common/getEnv';
import { AvoEnv, initAvo, OriginProduct, SegmentSourceType } from './Avo';

const analytics = AnalyticsBrowser.load({ writeKey: getEnv().segmentWriteKey });

// Initialize Amplitude Session Replay plugin - handles deviceId/sessionId sync automatically
const amplitudeApiKey = getEnv().amplitudeApiKey;
if (amplitudeApiKey) {
  createSegmentActionsPlugin({
    segmentInstance: analytics,
    amplitudeApiKey,
    sessionReplayOptions: {
      sampleRate: 1,
    },
  });
}

export const trackPageView = (pageName: string, properties = {}) => {
  return analytics.page(pageName, properties);
};

export const setUserProperties = (userId: string, properties: EventProperties) => {
  return analytics.identify(userId, properties);
};

const avoBridge = {
  make: () => {},
  logEvent: (eventName: string, properties: EventProperties) => {
    return analytics.track(eventName, properties);
  },
  setUserProperties,
  identify: (): null => {
    // setUserProperties is taking care of identifying for us with the correct traits
    return null;
  },
  unidentify: () => analytics.identify(null),
  logPage: trackPageView,
};

export const setupAnalytics = async () => {
  const options = {
    env: isDevelopment() ? AvoEnv.Dev : AvoEnv.Prod,
    webDebugger: false,
  };
  const parser = new UAParser();
  const browser = parser.getBrowser();
  const systemProperties = {
    appVersion: 'default',
    webBrowser: browser.name || 'Unknown',
    webBrowserVersion: browser.version || 'Unknown',
    originProduct: OriginProduct.SPM,
    segmentSourceType: SegmentSourceType.BROWSER,
    monetizenowProductIdSystem: [],
    monetizenowAccountIdSystem: '',
  };
  initAvo(options, systemProperties, {}, avoBridge);
};
